// Instance
import MainAPI from "@/app/apis/main/main-api.js";

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js";

// Query String
const queryString = require("querystring");

class PetOrderAPI extends MainAPI {
  /**
   * @params {Object} purchaseDetails
   * */
  async addPetPurchase(purchaseDetails) {
    return API.post(`${ENDPOINTS.POST_PET_ORDER}`, purchaseDetails);
  }

  /**
   * @params {Object} requestPurchaseDetails
   * */
  async requestPurchase(requestPurchaseDetails) {
    return API.post(
      `${ENDPOINTS.POST_REQUEST_PET_ORDER}`,
      requestPurchaseDetails
    );
  }

  /**
   * @params {Object} purchaseDetails
   * */
  async getPetPurchase(purchaseDetails) {
    return API.get(
      `${ENDPOINTS.GET_PET_ORDERS}?${queryString.stringify(purchaseDetails)}`
    );
  }

  /**
   * @params {*} petOrderId
   * */
  async deletePetOrder(petOrderId) {
    return API.delete(`${ENDPOINTS.DELETE_PET_ORDER}/${petOrderId}`);
  }

  /**
   * @params {Object} referenceId
   * */
  async getDogPurchase(referenceId) {
    return API.get(
      `${ENDPOINTS.GET_DOG_PURCHASE}?${queryString.stringify(referenceId)}`
    );
  }

  /**
   * @params {Integer} dogPurchaseId
   * @params {Object} requestDetails
   * */
  async requestRefund(dogPurchaseId, requestDetails) {
    return API.put(
      `${ENDPOINTS.GET_DOG_PURCHASE}/${dogPurchaseId}/refund`,
      requestDetails
    );
  }

  /**
   * @params integer dogPurchaseId
   * @params {Object} details
   * */
  async cancelDogPurchase(dogPurchaseId, details) {
    return API.put(
      `${ENDPOINTS.PUT_DOG_PURCHASE}/${dogPurchaseId}/update-dog-purchase-status`,
      details
    );
  }

  /**
   * @params {Object} dogPurchaseDetails
   * */
  async addDogPurchasePet(dogPurchaseDetails) {
    return API.post(`${ENDPOINTS.DOG_PURCHASE_ADD_PET}`, dogPurchaseDetails);
  }
}

export default new PetOrderAPI();
